import type { RootState } from '@core/core/store'
import type { CompanyId } from '@core/core/types'

import { companiesAdapter } from './companiesSlice'

const { selectAll, selectById } = companiesAdapter.getSelectors<RootState>(state => state.companies)

export const selectAllCompanies = (state: RootState) => selectAll(state)

export const selectCompanyById = (state: RootState, id: CompanyId | undefined) => {
  if (!id) return null

  return selectById(state, id)
}
